import { useState } from 'react';

import Modal from "./UI/Modal";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Form, Button } from 'react-bootstrap';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faFilter, faFilterCircleXmark } from "@fortawesome/free-solid-svg-icons";

import classes from "./FIIsFilterForm.module.css"

const FIIsFilterForm = (props) => {
    const [ticker, setTicker] = useState(props.filters.codigo ? props.filters.codigo.value : "");
    const [sector, setSector] = useState(props.filters.setor ? props.filters.setor.value : "");
    const [subSector, setSubSector] = useState(props.filters.subsetor ? props.filters.subsetor.value : "");

    const [lqd, setLqd] = useState(props.filters.lqd ? props.filters.lqd.value : 0);
    const [lqdOperator, setLqdOperator] = useState(props.filters.lqd ? props.filters.lqd.operator : 0);
    const [disableLqd, setDisableLqd] = useState(props.filters.lqd ? props.filters.lqd.operator === 0 : true);

    const [vacancy, setVacancy] = useState(props.filters.vacancy ? props.filters.vacancy.value : 0);
    const [vacancyOperator, setVacancyOperator] = useState(props.filters.vacancy ? props.filters.vacancy.operator : 0);
    const [disableVacancy, setDisableVacancy] = useState(props.filters.vacancy ? props.filters.vacancy.operator === 0 : true);

    const [xPoupanca, setXPoupanca] = useState(props.filters.xPoupanca ? props.filters.xPoupanca.value : 0);
    const [xPoupancaOperator, setXPoupancaOperator] = useState(props.filters.xPoupanca ? props.filters.xPoupanca.operator : 0);
    const [disableXPoupanca, setDisableXPoupanca] = useState(props.filters.xPoupanca ? props.filters.xPoupanca.operator === 0 : true);

    const [pvp, setPvp] = useState(props.filters.pvp ? props.filters.pvp.value : 0);
    const [pvpOperator, setPvpOperator] = useState(props.filters.pvp ? props.filters.pvp.operator : 0);
    const [disablePvp, setDisablePvp] = useState(props.filters.pvp ? props.filters.pvp.operator === 0 : true);

    const [dy1, setDy1] = useState(props.filters.dy1 ? props.filters.dy1.value : 0);
    const [dy1Operator, setDy1Operator] = useState(props.filters.dy1 ? props.filters.dy1.operator : 0);
    const [disableDy1, setDisableDy1] = useState(props.filters.dy1 ? props.filters.dy1.operator === 0 : true);

    const [dy3, setDy3] = useState(props.filters.dy3 ? props.filters.dy3.value : 0);
    const [dy3Operator, setDy3Operator] = useState(props.filters.dy3 ? props.filters.dy3.operator : 0);
    const [disableDy3, setDisableDy3] = useState(props.filters.dy3 ? props.filters.dy3.operator === 0 : true);

    const [dy6, setDy6] = useState(props.filters.dy6 ? props.filters.dy6.value : 0);
    const [dy6Operator, setDy6Operator] = useState(props.filters.dy6 ? props.filters.dy6.operator : 0);
    const [disableDy6, setDisableDy6] = useState(props.filters.dy6 ? props.filters.dy6.operator === 0 : true);

    const [dy12, setDy12] = useState(props.filters.dy12 ? props.filters.dy12.value : 0);
    const [dy12Operator, setDy12Operator] = useState(props.filters.dy12 ? props.filters.dy12.operator : 0);
    const [disableDy12, setDisableDy12] = useState(props.filters.dy12 ? props.filters.dy12.operator === 0 : true);

    // const [dyIPO, setDyIPO] = useState(props.filters.dyIPO ? props.filters.dyIPO.value : 0);
    // const [dyIPOOperator, setDyIPOOperator] = useState(props.filters.dyIPO ? props.filters.dyIPO.operator : 0);
    // const [disableDyIPO, setDisableDyIPO] = useState(props.filters.dyIPO ? props.filters.dyIPO.operator === 0 : true);

    const [vD, setVD] = useState(props.filters.vD ? props.filters.vD.value : 0);
    const [vDOperator, setVDOperator] = useState(props.filters.vD ? props.filters.vD.operator : 0);
    const [disableVD, setDisableVD] = useState(props.filters.vD ? props.filters.vD.operator === 0 : true);

    const [vM, setVM] = useState(props.filters.vM ? props.filters.vM.value : 0);
    const [vMOperator, setVMOperator] = useState(props.filters.vM ? props.filters.vM.operator : 0);
    const [disableVM, setDisableVM] = useState(props.filters.vM ? props.filters.vM.operator === 0 : true);

    const [vY, setVY] = useState(props.filters.vY ? props.filters.vY.value : 0);
    const [vYOperator, setVYOperator] = useState(props.filters.vY ? props.filters.vY.operator : 0);
    const [disableVY, setDisableVY] = useState(props.filters.vY ? props.filters.vY.operator === 0 : true);

    const [price, setPrice] = useState(props.filters.price ? props.filters.price.value : 0);
    const [priceOperator, setPriceOperator] = useState(props.filters.price ? props.filters.price.operator : 0);
    const [disablePrice, setDisablePrice] = useState(props.filters.price ? props.filters.price.operator === 0 : true);

    const changeTickerHandler = (value) => {
        setTicker(value);
    };

    const changeSectorHandler = (value) => {
        setSector(value);
    };

    const changeSubSectorHandler = (value) => {
        setSubSector(value);
    };

    const changeLqdHandler = (value) => {
        setLqd(value);
    };
    const changeLqdOperatorHandler = (value) => {
        if (value !== "") {
            setLqdOperator(value);
            setDisableLqd(false);
        } else {
            setDisableLqd(true);
        }
    };

    const changeVacancyHandler = (value) => {
        setVacancy(value);
    };
    const changeVacancyOperatorHandler = (value) => {
        if (value !== "") {
            setVacancyOperator(value);
            setDisableVacancy(false);
        } else {
            setDisableVacancy(true);
        }
    };

    const changeXPoupancaHandler = (value) => {
        setXPoupanca(value);
    };
    const changeXPoupancaOperatorHandler = (value) => {
        if (value !== "") {
            setXPoupancaOperator(value);
            setDisableXPoupanca(false);
        } else {
            setDisableXPoupanca(true);
        }
    };

    const changePvpHandler = (value) => {
        setPvp(value);
    };
    const changePvpOperatorHandler = (value) => {
        if (value !== "") {
            setPvpOperator(value);
            setDisablePvp(false);
        } else {
            setDisablePvp(true);
        }
    };

    const changeDy1Handler = (value) => {
        setDy1(value);
    };

    const changeDy1OperatorHandler = (value) => {
        if (value !== "") {
            setDy1Operator(value);
            setDisableDy1(false);
        } else {
            setDisableDy1(true);
        }
    };

    const changeDy3Handler = (value) => {
        setDy3(value);
    };
    const changeDy3OperatorHandler = (value) => {
        if (value !== "") {
            setDy3Operator(value);
            setDisableDy3(false);
        } else {
            setDisableDy3(true);
        }
    };

    const changeDy6Handler = (value) => {
        setDy6(value);
    };
    const changeDy6OperatorHandler = (value) => {
        if (value !== "") {
            setDy6Operator(value);
            setDisableDy6(false);
        } else {
            setDisableDy6(true);
        }
    };

    const changeDy12Handler = (value) => {
        setDy12(value);
    };
    const changeDy12OperatorHandler = (value) => {
        if (value !== "") {
            setDy12Operator(value);
            setDisableDy12(false);
        } else {
            setDisableDy12(true);
        }
    };

    // const changeDyIPOHandler = (value) => {
    //     setDyIPO(value);
    // };
    // const changeDyIPOOperatorHandler = (value) => {
    //     if (value !== "") {
    //         setDyIPOOperator(value);
    //         setDisableDyIPO(false);
    //     } else {
    //         setDisableDyIPO(true);
    //     }
    // };

    const changeVDHandler = (value) => {
        setVD(value);
    };
    const changeVDOperatorHandler = (value) => {
        if (value !== "") {
            setVDOperator(value);
            setDisableVD(false);
        } else {
            setDisableVD(true);
        }
    };

    const changeVMHandler = (value) => {
        setVM(value);
    };
    const changeVMOperatorHandler = (value) => {
        if (value !== "") {
            setVMOperator(value);
            setDisableVM(false);
        } else {
            setDisableVM(true);
        }
    };

    const changeVYHandler = (value) => {
        setVY(value);
    };
    const changeVYOperatorHandler = (value) => {
        if (value !== "") {
            setVYOperator(value);
            setDisableVY(false);
        } else {
            setDisableVY(true);
        }
    };

    const changePriceHandler = (value) => {
        setPrice(value);
    };
    const changePriceOperatorHandler = (value) => {
        if (value !== "") {
            setPriceOperator(value);
            setDisablePrice(false);
        } else {
            setDisablePrice(true);
        }
    };

    const filter = () => {
        const filters = {};
        if (ticker !== "") filters['codigo'] = { value: ticker };
        if (sector !== "") filters['setor'] = { value: sector };
        if (subSector !== "") filters['subsetor'] = { value: subSector };

        if (lqdOperator !== 0) filters['lqd'] = { value: lqd, operator: lqdOperator };
        if (vacancyOperator !== 0) filters['vacancy'] = { value: vacancy, operator: vacancyOperator };
        if (xPoupancaOperator !== 0) filters['xPoupanca'] = { value: xPoupanca, operator: xPoupancaOperator };
        if (pvpOperator !== 0) filters['pvp'] = { value: pvp, operator: pvpOperator };

        if (dy1Operator !== 0) filters['dy1'] = { value: dy1, operator: dy1Operator };
        if (dy3Operator !== 0) filters['dy3'] = { value: dy3, operator: dy3Operator };
        if (dy6Operator !== 0) filters['dy6'] = { value: dy6, operator: dy6Operator };
        if (dy12Operator !== 0) filters['dy12'] = { value: dy12, operator: dy12Operator };
        // if (dyIPOOperator !== 0) filters['dyIPO'] = { value: dyIPO, operator: dyIPOOperator };

        if (vDOperator !== 0) filters['vD'] = { value: vD, operator: vDOperator };
        if (vMOperator !== 0) filters['vM'] = { value: vM, operator: vMOperator };
        if (vYOperator !== 0) filters['vY'] = { value: vY, operator: vYOperator };
        if (priceOperator !== 0) filters['price'] = { value: price, operator: priceOperator };
        // console.log(filters);
        props.updateFilters(filters);
    };

    const clearFilters = () => {
        const filters = {};
        props.updateFilters(filters);
    };

    const closeFilterForm = () => {
        props.closeFilterForm();
    };

    return (
        <Modal modalClass={classes.modal} onClose={props.onClose}>
            <Form className='borderSpace'>
                <Container>
                    <Row>
                        <Col xs={12} className='minSpace text-center bg-success text-white'>FILTRAR FUNDOS IMOBILIÁRIOS</Col>
                    </Row>
                    <Row>
                        <Col xs={4} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Ticker:</small></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={ticker}
                                    onChange={(e) => changeTickerHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={4} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Setor:</small></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={sector}
                                    onChange={(e) => changeSectorHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={4} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Segmento:</small></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={subSector}
                                    onChange={(e) => changeSubSectorHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Liquidez diária:</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={lqdOperator}
                                    onChange={(e) => changeLqdOperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={lqd}
                                    disabled={disableLqd}
                                    onChange={(e) => changeLqdHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Vacância:</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={vacancyOperator}
                                    onChange={(e) => changeVacancyOperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={vacancy}
                                    disabled={disableVacancy}
                                    onChange={(e) => changeVacancyHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Rendimento x Poupanca:</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={xPoupancaOperator}
                                    onChange={(e) => changeXPoupancaOperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={xPoupanca}
                                    disabled={disableXPoupanca}
                                    onChange={(e) => changeXPoupancaHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>P/VP:</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={pvpOperator}
                                    onChange={(e) => changePvpOperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={pvp}
                                    disabled={disablePvp}
                                    onChange={(e) => changePvpHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Dividend Yield 1 Mês:</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={dy1Operator}
                                    onChange={(e) => changeDy1OperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={dy1}
                                    disabled={disableDy1}
                                    onChange={(e) => changeDy1Handler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Dividend Yield 3 Meses:</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={dy3Operator}
                                    onChange={(e) => changeDy3OperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={dy3}
                                    disabled={disableDy3}
                                    onChange={(e) => changeDy3Handler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Dividend Yield 6 Meses:</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={dy6Operator}
                                    onChange={(e) => changeDy6OperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={dy6}
                                    disabled={disableDy6}
                                    onChange={(e) => changeDy6Handler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Dividend Yield 12 Meses:</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={dy12Operator}
                                    onChange={(e) => changeDy12OperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={dy12}
                                    disabled={disableDy12}
                                    onChange={(e) => changeDy12Handler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Variação 1 Dia:</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={vDOperator}
                                    onChange={(e) => changeVDOperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={vD}
                                    disabled={disableVD}
                                    onChange={(e) => changeVDHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Variação 1 Mês:</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={vMOperator}
                                    onChange={(e) => changeVMOperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={vM}
                                    disabled={disableVM}
                                    onChange={(e) => changeVMHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Variação 1 Ano:</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={vYOperator}
                                    onChange={(e) => changeVYOperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={vY}
                                    disabled={disableVY}
                                    onChange={(e) => changeVYHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Preço:</small></Form.Label>
                                <Form.Select as="select" className={classes.filterFormControl}
                                    value={priceOperator}
                                    onChange={(e) => changePriceOperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={price}
                                    disabled={disablePrice}
                                    onChange={(e) => changePriceHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="pt-1">
                        <Col xs={5} className='minSpace'>
                            <Form.Group>
                                <Button variant="primary" className="filterFormButton" onClick={filter}>
                                    <FontAwesomeIcon icon={faFilter} />&nbsp;Filtrar
                                </Button>
                            </Form.Group>
                        </Col>

                        <Col xs={5} className='minSpace'>
                            <Form.Group>
                                <Button variant="primary" className="filterFormButton" onClick={clearFilters}>
                                    <FontAwesomeIcon icon={faFilterCircleXmark} />&nbsp;Limpar
                                </Button>
                            </Form.Group>
                        </Col>

                        <Col xs={2} className='minSpace'>
                            <Button variant="warning" className="filterFormButton" onClick={closeFilterForm}>
                                <FontAwesomeIcon icon={faClose} />&nbsp;Fechar
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Form >
        </Modal >
    );
};

export default FIIsFilterForm;